<div class="page-container qr-poster-page" data-tour="qr-poster-editor">
  <div class="page-header">
    <h1>{{ 'QR_POSTER_TEMPLATE.PAGE_TITLE' | translate }}</h1>
    <p class="page-subtitle">{{ 'QR_POSTER_TEMPLATE.PAGE_SUBTITLE' | translate }}</p>
  </div>

  <div class="builder-mode-controls">
    <div class="builder-mode-switch">
      <button nz-button [nzType]="builderMode === 'simple' ? 'primary' : 'default'" type="button" (click)="onBuilderModeChange('simple')">
        <i nz-icon nzType="edit"></i>
        {{ 'QR_POSTER_TEMPLATE.BUILDER.TAB_SIMPLE' | translate }}
      </button>
      <button nz-button [nzType]="builderMode === 'advanced' ? 'primary' : 'default'" type="button" (click)="onBuilderModeChange('advanced')">
        <i nz-icon nzType="build"></i>
        {{ 'QR_POSTER_TEMPLATE.BUILDER.TAB_ADVANCED' | translate }}
      </button>
      <span *ngIf="shouldRenderSignOrderTab"
        class="sign-order-tab-tooltip"
        nz-tooltip
        [nzTooltipTitle]="signOrderCtaTooltipKey ? (signOrderCtaTooltipKey | translate) : null"
        [attr.tabindex]="isSignOrderCtaDisabled && signOrderCtaTooltipKey ? 0 : null"
        [attr.aria-label]="isSignOrderCtaDisabled && signOrderCtaTooltipKey
          ? (signOrderCtaTooltipKey | translate)
          : null">
        <button nz-button [nzType]="builderMode === 'sign-order' ? 'primary' : 'default'" type="button"
          (click)="startNewSignOrder()"
          [disabled]="isSignOrderCtaDisabled"
          class="sign-order-tab-btn"
          [class.sign-order-tab-btn--attention]="signOrderCtaAttentionActive">
          <i nz-icon nzType="shopping-cart"></i>
          <span>{{ 'QR_POSTER_TEMPLATE.SIGN_ORDER_CTA_BUTTON' | translate }}</span>
          <span class="sign-order-new-badge" aria-hidden="true">
            {{ 'QR_POSTER_TEMPLATE.NEW_BADGE' | translate }}
          </span>
        </button>
      </span>
    </div>
  </div>

  <div *ngIf="signOrderRouteNoticeKey" class="sign-order-route-notice">
    <nz-alert
      nzShowIcon
      nzClosable
      [nzType]="signOrderRouteNotice === 'unavailable' ? 'warning' : 'info'"
      [nzMessage]="signOrderRouteNoticeKey | translate"
      (nzOnClose)="dismissSignOrderRouteNotice()">
    </nz-alert>
    <button *ngIf="signOrderRouteNotice === 'no-properties'"
      nz-button
      nzType="default"
      type="button"
      class="sign-order-route-notice-action"
      (click)="goToPropertiesForSignOrder()">
      {{ 'QR_POSTER_TEMPLATE.GO_TO_PROPERTIES' | translate }}
    </button>
    <p *ngIf="signOrderRouteNotice === 'unavailable' && catalogReason" class="sign-order-route-notice-reason">
      {{ catalogReason }}
    </p>
  </div>

  <div class="qr-poster-loading-state" *ngIf="isLoading; else editorContent">
    <nz-spin [nzSpinning]="true"></nz-spin>
  </div>

  <ng-template #editorContent>
    <div class="template-layout" *ngIf="form">
      <div *ngIf="builderMode === 'simple'" class="simple-layout">
        <form class="editor-panel" nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
          <nz-alert
            *ngIf="!hasProperties"
            nzType="info"
            [nzMessage]="'QR_POSTER_TEMPLATE.NO_PROPERTIES_INFO' | translate"
            nzShowIcon
            class="info-alert"
          ></nz-alert>

          <nz-tabset [nzAnimated]="false" [nzSelectedIndex]="activeTabIndex" (nzSelectedIndexChange)="onLanguageChange($event)">
            <nz-tab *ngFor="let lang of languages" [nzTitle]="('LANGUAGE_NAMES.' + lang.toUpperCase()) | translate">
              <div class="language-panel" [formGroupName]="lang">
                <ng-container *ngFor="let field of visibleFields; trackBy: trackByField">
                  <div class="form-field" [ngClass]="{ 'over-limit': exceedsSoftLimit(lang, field) }" *ngIf="field !== 'checkInInfo'">
                    <label class="field-label" [attr.id]="getInputId(lang, field) + '-label'">
                      {{ fieldConfig[field].labelKey | translate }}
                      <span nz-tooltip [nzTooltipTitle]="fieldConfig[field].descriptionKey | translate" class="info-icon">
                        <i nz-icon nzType="info-circle"></i>
                      </span>
                    </label>

                    <ng-container [ngSwitch]="fieldConfig[field].type">
                      <input
                        *ngSwitchCase="'text'"
                        nz-input
                        [id]="getInputId(lang, field)"
                        [attr.maxLength]="limits[field].hard"
                        [formControlName]="field"
                      />
                      <textarea
                        *ngSwitchCase="'textarea'"
                        nz-input
                        [rows]="fieldConfig[field].rows || 4"
                        [id]="getInputId(lang, field)"
                        [attr.maxLength]="limits[field].hard"
                        [formControlName]="field"
                      ></textarea>
                    </ng-container>

                    <div class="field-meta">
                      <span class="char-count">{{ getCharacterCount(lang, field) }} / {{ limits[field].soft }}</span>
                      <span *ngIf="exceedsSoftLimit(lang, field)" class="limit-warning">
                        {{ 'QR_POSTER_TEMPLATE.OVER_LIMIT_WARNING' | translate }}
                      </span>
                    </div>
                  </div>
                </ng-container>
              </div>
            </nz-tab>
          </nz-tabset>

          <div class="actions">
            <button nz-button type="button" nzType="default" (click)="resetToDefault()" [disabled]="isResetDisabled">
              {{ 'QR_POSTER_TEMPLATE.RESET' | translate }}
            </button>
            <button nz-button type="button" nzType="default" (click)="generateTestPdf()" [disabled]="isLoading || isSaving || isGeneratingPdf" [nzLoading]="isGeneratingPdf">
              {{ 'QR_POSTER_TEMPLATE.GENERATE_TEST_PDF' | translate }}
            </button>
            <button nz-button nzType="primary" type="submit" [disabled]="isSaveDisabled" [nzLoading]="isSaving">
              {{ 'QR_POSTER_TEMPLATE.SAVE' | translate }}
            </button>
          </div>
        </form>

        <div class="preview-panel">
          <div class="preview-header">
            <h2>{{ 'QR_POSTER_TEMPLATE.PREVIEW.TITLE' | translate }}</h2>
            <p>{{ 'QR_POSTER_TEMPLATE.PREVIEW.DESCRIPTION' | translate }}</p>
          </div>

          <div
            class="simple-canonical-preview"
            *ngIf="isSimplePosterPreviewLoading || isSimplePosterPreviewReady"
          >
            <div class="simple-canonical-preview-page">
              <div class="simple-canonical-preview-loading" *ngIf="isSimplePosterPreviewLoading">
                <nz-spin [nzSpinning]="true"></nz-spin>
              </div>
              <canvas
                #simplePosterPreviewCanvas
                class="simple-canonical-preview-canvas"
                [class.simple-canonical-preview-canvas--hidden]="!isSimplePosterPreviewReady"
                role="img"
                [attr.aria-label]="'QR_POSTER_TEMPLATE.PREVIEW.TITLE' | translate"
              ></canvas>
              <canvas
                #simplePosterPreviewRenderCanvas
                class="simple-canonical-preview-render-canvas"
                aria-hidden="true"
              ></canvas>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="builderMode === 'advanced'" class="advanced-layout" [style.--builder-workspace-height]="workspaceHeightPx + 'px'" (pointerdown)="onAdvancedLayoutPointerDown($event)">
        <aside class="advanced-sidebar">
          <div class="builder-card">
            <div class="card-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.TEMPLATES' | translate }}</div>
            <label class="card-label">{{ 'QR_POSTER_TEMPLATE.BUILDER.SELECT_TEMPLATE' | translate }}</label>
            <p class="card-helper">{{ 'QR_POSTER_TEMPLATE.BUILDER.TEMPLATE_HELPER' | translate }}</p>
            <nz-select [ngModel]="selectedSystemTemplateId" (ngModelChange)="onSelectSystemTemplate($event)">
              <nz-option-group *ngIf="userTemplates.length" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.MY_TEMPLATES' | translate">
                <nz-option *ngFor="let template of userTemplates" [nzValue]="'user:' + template.id" [nzLabel]="getTemplateName('user:' + template.id)"></nz-option>
              </nz-option-group>
              <nz-option-group [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.TEMPLATE_GROUP_SYSTEM' | translate">
                <nz-option *ngFor="let template of systemTemplates" [nzValue]="'system:' + template.id" [nzLabel]="getTemplateName('system:' + template.id)"></nz-option>
              </nz-option-group>
            </nz-select>
            <div class="template-manage-list" *ngIf="userTemplates.length">
              <div
                class="template-manage-item"
                *ngFor="let template of userTemplates"
                [class.template-manage-item--selected]="'user:' + template.id === selectedSystemTemplateId"
              >
                <div
                  class="template-manage-item__name-row"
                  (click)="onSelectSystemTemplate('user:' + template.id)"
                >
                  <span
                    class="template-manage-name"
                    nz-tooltip
                    [nzTooltipTitle]="template.name"
                  >{{ template.name }}</span>
                  <span class="template-manage-active" *ngIf="template.id === activeTemplateId">{{ 'QR_POSTER_TEMPLATE.BUILDER.ACTIVE_SHORT' | translate }}</span>
                </div>
                <div class="template-manage-item__actions" (click)="$event.stopPropagation()">
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    type="button"
                    (click)="setTemplateActiveFromList(template)"
                    [disabled]="isSavingTemplate"
                    nz-tooltip
                    [nzTooltipTitle]="template.id === activeTemplateId
                      ? ('QR_POSTER_TEMPLATE.BUILDER.ACTIVE_TEMPLATE_TOOLTIP' | translate)
                      : ('QR_POSTER_TEMPLATE.BUILDER.MAKE_ACTIVE_TOOLTIP' | translate)"
                    [attr.aria-label]="template.id === activeTemplateId
                      ? ('QR_POSTER_TEMPLATE.BUILDER.ACTIVE_TEMPLATE_TOOLTIP' | translate)
                      : ('QR_POSTER_TEMPLATE.BUILDER.MAKE_ACTIVE_TOOLTIP' | translate)"
                    class="template-activate-button"
                    [class.template-activate-button--active]="template.id === activeTemplateId"
                  >
                    <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    type="button"
                    (click)="duplicateUserTemplate(template)"
                    [disabled]="isSavingTemplate"
                    nz-tooltip
                    [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DUPLICATE_TEMPLATE' | translate"
                    [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.DUPLICATE_TEMPLATE' | translate"
                    class="template-duplicate-button"
                  >
                    <i nz-icon nzType="copy" nzTheme="outline"></i>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    type="button"
                    (click)="openRenameTemplateModal(template)"
                    nz-tooltip
                    [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.RENAME_TEMPLATE' | translate"
                    class="template-rename-button"
                  >
                    <i nz-icon nzType="form"></i>
                  </button>
                  <button
                    nz-button
                    nzType="text"
                    nzShape="circle"
                    nzDanger
                    type="button"
                    (click)="onDeleteUserTemplate(template)"
                    nz-tooltip
                    [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DELETE_TEMPLATE' | translate"
                    class="template-delete-button"
                  >
                    <i nz-icon nzType="delete"></i>
                  </button>
                </div>
              </div>
            </div>
            <p class="card-description">
              {{ selectedSystemTemplateId.startsWith('user:')
                ? ('QR_POSTER_TEMPLATE.BUILDER.MY_TEMPLATE_DESCRIPTION' | translate)
                : (selectedTemplateDescription) }}
            </p>
            <div class="template-variant-list" *ngIf="selectedTemplateVariants as variants">
              <label class="card-label">{{ 'QR_POSTER_TEMPLATE.BUILDER.COLOR_VARIANT' | translate }}</label>
              <div class="variant-chip-list">
                <button
                  nz-button
                  *ngFor="let variant of variants"
                  [ngClass]="{ 'variant-active': variant.id === selectedVariantId }"
                  [nzType]="variant.id === selectedVariantId ? 'primary' : 'default'"
                  [nzSize]="'small'"
                  type="button"
                  (click)="onSelectVariant(variant.id)"
                >
                  <span class="variant-swatch" [style.backgroundColor]="variant.colors.primary || variant.colors.accent || variant.colors.ctaBg || variant.colors.headerBg || variant.colors.iconColor || '#888'"></span>
                  {{ getVariantDisplayName(variant) }}
                </button>
              </div>
            </div>
            <div class="template-status-note" [ngClass]="{ 'template-status-note--empty': !activeTemplateId, 'template-status-note--active': !!activeTemplateId }">{{ activeTemplateStatusLabel }}</div>
          </div>

          <div class="builder-card">
            <div class="card-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.BLOCKS' | translate }}</div>
            <p class="card-helper">{{ 'QR_POSTER_TEMPLATE.BUILDER.ADD_BLOCK_HELPER' | translate }}</p>
            <div class="builder-button-grid">
              <button
                nz-button
                nzType="default"
                type="button"
                *ngFor="let option of blockTypeOptions"
                (click)="addBlock(option.key)"
                nz-tooltip
                [nzTooltipTitle]="option.labelKey | translate"
                [attr.aria-label]="option.labelKey | translate"
                class="builder-icon-button"
              >
                <i nz-icon [nzType]="option.icon"></i>
              </button>
            </div>
          </div>

          <div class="builder-card">
            <div class="card-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.BLOCK_ACTIONS' | translate }}</div>
            <div class="builder-actions">
              <button nz-button nzType="default" type="button" (click)="duplicateSelectedBlock()" [disabled]="!selectedBlock" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DUPLICATE_BLOCK' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.DUPLICATE_BLOCK' | translate">
                <i nz-icon nzType="copy"></i>
              </button>
              <button nz-button nzType="default" type="button" (click)="deleteSelectedBlock()" [disabled]="!canDeleteSelectedBlock" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DELETE_BLOCK' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.DELETE_BLOCK' | translate">
                <i nz-icon nzType="delete"></i>
              </button>
              <button nz-button nzType="default" type="button" (click)="sendSelectedBlockBackward()" [disabled]="!canSendSelectedBlockBackward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.SEND_BACKWARD' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.SEND_BACKWARD' | translate">
                <i nz-icon nzType="down"></i>
              </button>
              <button nz-button nzType="default" type="button" (click)="bringSelectedBlockForward()" [disabled]="!canBringSelectedBlockForward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.BRING_FORWARD' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.BRING_FORWARD' | translate">
                <i nz-icon nzType="up"></i>
              </button>
              <button nz-button nzType="default" type="button" (click)="openLayerModal()" [disabled]="!workingTemplate" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.LAYER_ORDER' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.LAYER_ORDER' | translate">
                <i nz-icon nzType="ordered-list"></i>
              </button>
            </div>
          </div>

          <div class="builder-card">
            <div class="card-title">
              {{ 'QR_POSTER_TEMPLATE.BUILDER.VARIABLES' | translate }}
              <i nz-icon nzType="info-circle" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.VARIABLES_TOOLTIP' | translate"></i>
            </div>
            <div class="variable-group" *ngFor="let group of variableGroups">
              <div class="group-title">{{ group.labelKey | translate }}</div>
              <button nz-button nzType="default" type="button" class="variable-card" *ngFor="let variable of group.variables" (click)="insertVariable(variable.token)" nz-tooltip [nzTooltipTitle]="getVariablePreviewValue(variable.token)">
                <span class="variable-card__label">{{ variable.labelKey | translate }}</span>
                <span class="variable-card__token">{{ variable.token }}</span>
              </button>
            </div>
            <div class="variable-group">
              <div class="group-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.VARIABLE_GROUP_IMAGES' | translate }}</div>
              <button nz-button nzType="default" type="button" class="variable-card" (click)="addBlock('companyLogo')">
                <i nz-icon nzType="picture" class="variable-card__icon"></i>
                <span class="variable-card__label">{{ 'QR_POSTER_TEMPLATE.BUILDER.ADD_LOGO' | translate }}</span>
              </button>
            </div>
          </div>
        </aside>

        <section class="advanced-canvas-wrap">
          <div class="builder-canvas-card">
            <div class="canvas-toolbar builder-toolbar">
              <div class="canvas-toolbar__left toolbar-status">
                <div class="toolbar-status">
                  <span class="status-chip" [ngClass]="{ unsaved: hasUnsavedAdvancedChanges }">{{ advancedStatusLabel }}</span>
                </div>
              </div>
              <div class="canvas-toolbar__center toolbar-actions">
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="saveAdvancedTemplateChanges()" [disabled]="!workingTemplate || isSavingTemplate || !hasUnsavedAdvancedChanges || hasFooterTextContrastViolation" [nzLoading]="isSavingTemplate" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.SAVE_TEMPLATE' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.SAVE_TEMPLATE' | translate">
                  <i nz-icon nzType="save"></i>
                </button>
                <button nz-button nzType="primary" nzShape="circle" type="button" (click)="confirmSaveAdvancedTemplate()" [disabled]="!workingTemplate || isSavingTemplate || hasFooterTextContrastViolation" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.SET_ACTIVE' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.SET_ACTIVE' | translate">
                  <i nz-icon nzType="check-circle"></i>
                </button>
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="generateTestPdf()" [nzLoading]="isGeneratingPdf" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.GENERATE_TEST_PDF' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.GENERATE_TEST_PDF' | translate">
                  <i nz-icon nzType="file-pdf"></i>
                </button>
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="undo()" [disabled]="!canUndo" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.UNDO' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.UNDO' | translate">
                  <i nz-icon nzType="undo"></i>
                </button>
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="redo()" [disabled]="!canRedo" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.REDO' | translate" [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.REDO' | translate">
                  <i nz-icon nzType="redo"></i>
                </button>
              </div>
              <div class="canvas-toolbar__right toolbar-zoom">
                <span class="zoom-label">{{ 'QR_POSTER_TEMPLATE.BUILDER.ZOOM' | translate }}</span>
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="zoomOut()" [disabled]="!canZoomOut" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.ZOOM_OUT' | translate">
                  <i nz-icon nzType="minus"></i>
                </button>
                <span class="zoom-display">{{ zoomDisplayLabel }}</span>
                <button nz-button nzType="default" nzShape="circle" type="button" (click)="zoomIn()" [disabled]="!canZoomIn" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.ZOOM_IN' | translate">
                  <i nz-icon nzType="plus"></i>
                </button>
                <button nz-button nzType="default" type="button" class="zoom-fit-button" [nzType]="zoomMode === 'fit' ? 'primary' : 'default'" (click)="setZoom('fit')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.ZOOM_FIT' | translate">
                  Fit
                </button>
              </div>
            </div>
            <div class="qr-overlap-warning" *ngIf="hasQrOverlapWarning">
              <i nz-icon nzType="warning"></i>
              <span>{{ 'QR_POSTER_TEMPLATE.BUILDER.QR_OVERLAP_WARNING' | translate }}</span>
            </div>

            <div class="canvas-stage" #canvasStage>
              <div class="poster-page" #posterPage [style.width.px]="canvasWidthPx" [style.height.px]="canvasHeightPx" (pointerdown)="onCanvasPointerDown($event)">
                <div class="poster-safe-margin"></div>
                <div
                  class="canvas-guide"
                  *ngFor="let guide of guideLines"
                  [ngClass]="guide.orientation"
                  [style.left.px]="guide.orientation === 'vertical' ? guide.positionMm * canvasScalePxPerMm : null"
                  [style.top.px]="guide.orientation === 'horizontal' ? guide.positionMm * canvasScalePxPerMm : null"
                ></div>
                <div
                  class="marquee-selection"
                  *ngIf="marqueeSelectionRect"
                  [style.left.px]="marqueeSelectionRect.leftPx"
                  [style.top.px]="marqueeSelectionRect.topPx"
                  [style.width.px]="marqueeSelectionRect.widthPx"
                  [style.height.px]="marqueeSelectionRect.heightPx"
                ></div>
                <ng-container *ngFor="let block of workingTemplate?.blocks; trackBy: trackByBlock">
                <div
                  class="canvas-block"
                  *ngIf="shouldRenderAdvancedTemplateBlock(block) && (block.type !== 'footer' || showFooterInPreview)"
                  [attr.data-block-id]="block.id"
                  [attr.data-block-type]="block.type"
                  [ngClass]="{
                    selected: selectedBlockIds.includes(block.id),
                    'warning-overlap': isQrOverlapWarningBlock(block),
                    'text-fit-warning': hasPreviewTextFitWarning(block),
                    locked: block.locked,
                    'is-background': block.type === 'rectangle',
                    'is-line': block.type === 'line',
                    'is-footer': block.type === 'footer',
                    'is-media': isMediaBlock(block)
                  }"
                  [ngStyle]="getCanvasBlockStyles(block)"
                  (click)="onBlockClick(block, $event)"
                  (pointerdown)="onBlockPointerDown(block, $event)"
                  (dblclick)="startInlineEdit(block, $event)"
                >
                  <div class="block-badge" *ngIf="shouldShowBlockBadge(block)">{{ getBlockBadgeLabel(block) }}</div>
                  <div class="block-warning-badge" *ngIf="hasPreviewTextFitWarning(block)" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.TEXT_CLIP_WARNING' | translate">!</div>
                  <div class="rotation-badge" *ngIf="isBlockRotating(block)">{{ getRotationBadgeLabel(block) }}</div>
                  <ng-container [ngSwitch]="block.type">
                    <ng-container *ngSwitchCase="'qrCode'">
                      <img *ngIf="previewQrDataUrl" [src]="previewQrDataUrl" alt="QR code" class="block-logo" style="object-fit: contain;" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'companyLogo'">
                      <img [src]="previewLogoUrl" alt="Company logo" class="block-logo" [style.objectFit]="getImageObjectFit(block)" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'image'">
                      <img *ngIf="getImageBlockSource(block); else imagePlaceholder" [src]="getImageBlockSource(block)" alt="Poster block" class="block-logo" [style.objectFit]="getImageObjectFit(block)" />
                      <ng-template #imagePlaceholder>
                        <div class="image-placeholder">
                          <i nz-icon nzType="picture"></i>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngSwitchCase="'icon'">
                      <i
                        nz-icon
                        *ngIf="getBlockIconType(block) as iconType"
                        [nzType]="iconType"
                        class="block-preview-icon"
                        [style.fontSize.px]="getPreviewIconSizePx(block)"
                        [style.color]="block.style?.color || themeColor"
                      ></i>
                    </ng-container>
                    <ng-container *ngSwitchCase="'iconText'">
                      <div
                        class="icon-text-row"
                        [ngStyle]="getIconTextRowStyles(block, canvasScalePxPerMm)"
                      >
                        <i
                          nz-icon
                          *ngIf="getBlockIconType(block) as iconType"
                          [nzType]="iconType"
                          class="block-preview-icon"
                          [style.fontSize.px]="getPreviewIconSizePx(block)"
                          [style.color]="block.style?.iconColor || block.style?.color || themeColor"
                        ></i>
                        <textarea
                          *ngIf="isBlockEditing(block)"
                          class="block-inline-editor"
                          [style.background-color]="getInlineEditorBackground(block)"
                          [value]="inlineEditDraft"
                          [attr.data-inline-editor]="block.id"
                          (input)="updateInlineEditDraft($any($event.target).value)"
                          (blur)="commitInlineEdit()"
                          (keydown)="onInlineEditorKeydown($event)"
                          (click)="$event.stopPropagation()"
                        ></textarea>
                        <span class="block-text" *ngIf="!isBlockEditing(block)" [ngStyle]="getCanvasTextStyles(block)">{{ resolvePreviewText(block) }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'iconMultilineText'">
                      <i
                        nz-icon
                        *ngIf="getBlockIconType(block) as iconType"
                        class="block-preview-icon block-preview-icon--multiline"
                        [ngStyle]="getIconMultilineTextIconStyles(block)"
                        [nzType]="iconType"
                        [style.color]="block.style?.iconColor || block.style?.color || themeColor"
                      ></i>
                      <span class="block-text block-text--multiline" *ngIf="!isBlockEditing(block)" [ngStyle]="getIconMultilineTextStyles(block)">
                        <ng-container *ngFor="let line of getIconMultilineTextLines(block); let i = index">
                          {{ line }}<br *ngIf="i < getIconMultilineTextLines(block).length - 1" />
                        </ng-container>
                      </span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'footer'">
                      <div class="footer-preview" *ngIf="showFooterInPreview">
                        <span>www.scanafy.de</span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'line'"></ng-container>
                    <ng-container *ngSwitchCase="'emergencyNumbers'">
                      <div class="emergency-row" *ngFor="let row of block.content?.rows">
                        <span class="emergency-label">{{ row.label }}</span>
                        <span class="emergency-value">{{ row.value }}</span>
                        <span class="emergency-desc" *ngIf="row.description">{{ row.description }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <textarea
                        *ngIf="isBlockEditing(block)"
                        class="block-inline-editor"
                        [style.background-color]="getInlineEditorBackground(block)"
                        [value]="inlineEditDraft"
                        [attr.data-inline-editor]="block.id"
                        (input)="updateInlineEditDraft($any($event.target).value)"
                        (blur)="commitInlineEdit()"
                        (keydown)="onInlineEditorKeydown($event)"
                        (click)="$event.stopPropagation()"
                      ></textarea>
                      <span class="block-text" *ngIf="!isBlockEditing(block)" [ngStyle]="getCanvasTextStyles(block)">{{ resolvePreviewText(block) }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="shouldShowResizeHandles(block)">
                    <button type="button" class="resize-handle resize-handle--n" (pointerdown)="onResizeHandlePointerDown(block, 'n', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--s" (pointerdown)="onResizeHandlePointerDown(block, 's', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--w" (pointerdown)="onResizeHandlePointerDown(block, 'w', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--e" (pointerdown)="onResizeHandlePointerDown(block, 'e', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--nw" (pointerdown)="onResizeHandlePointerDown(block, 'nw', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--ne" (pointerdown)="onResizeHandlePointerDown(block, 'ne', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--sw" (pointerdown)="onResizeHandlePointerDown(block, 'sw', $event)"></button>
                    <button type="button" class="resize-handle resize-handle--se" (pointerdown)="onResizeHandlePointerDown(block, 'se', $event)"></button>
                  </ng-container>
                  <button
                    *ngIf="shouldShowRotateHandle(block)"
                    type="button"
                    class="rotate-handle"
                    (pointerdown)="onRotateHandlePointerDown(block, $event)"
                    nz-tooltip
                    [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.ROTATE' | translate"
                    [attr.aria-label]="'QR_POSTER_TEMPLATE.BUILDER.ROTATE' | translate"
                  >
                    <i nz-icon nzType="reload"></i>
                  </button>
                </div>
                </ng-container>
              </div>
            </div>
          </div>
        </section>

        <aside class="advanced-inspector builder-card">
          <div class="card-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.INSPECTOR' | translate }}</div>

          <ng-container *ngIf="isMultiSelection; else singleInspector">
            <section class="inspector-section">
              <div class="inspector-title">{{ multiSelectionLabel }}</div>
              <div class="builder-actions secondary">
                <button nz-button nzType="default" type="button" (click)="duplicateSelectedBlock()" [disabled]="!selectedBlocks.length" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DUPLICATE_BLOCK' | translate">
                  <i nz-icon nzType="copy"></i>
                </button>
                <button nz-button nzType="default" type="button" (click)="deleteSelectedBlock()" [disabled]="!canDeleteSelectedBlock" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.DELETE_BLOCK' | translate">
                  <i nz-icon nzType="delete"></i>
                </button>
                <button nz-button nzType="default" type="button" (click)="sendSelectedBlockBackward()" [disabled]="!canSendSelectedBlockBackward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.SEND_BACKWARD' | translate">
                  <i nz-icon nzType="down"></i>
                </button>
                <button nz-button nzType="default" type="button" (click)="bringSelectedBlockForward()" [disabled]="!canBringSelectedBlockForward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.BRING_FORWARD' | translate">
                  <i nz-icon nzType="up"></i>
                </button>
              </div>
            </section>
          </ng-container>

          <ng-template #singleInspector>
            <ng-container *ngIf="selectedBlock as block; else emptyInspector">
            <section class="inspector-section inspector-section--selected">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.SELECTED_ELEMENT' | translate }}</div>
              <div class="selected-element-name">{{ selectedBlockDisplayName }}</div>
              <div class="selected-element-subtitle" *ngIf="selectedBlockSecondaryLabel">{{ selectedBlockSecondaryLabel }}</div>
            </section>
            <section class="inspector-section" *ngIf="isTextBlock(block) || isImageBlock(block) || isIconBlock(block) || isIconTextBlock(block) || isIconMultilineTextBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.CONTENT' | translate }}</div>
              <div class="inspector-grid" *ngIf="isTextBlock(block)">
                <ng-container *ngIf="!isBlockContentVariable(block)">
                  <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT' | translate }}</label>
                  <textarea nz-input rows="3" [ngModel]="block.content?.text || ''" (ngModelChange)="updateSelectedBlockContent('text', $event)"></textarea>
                </ng-container>
                <ng-container *ngIf="isBlockContentVariable(block)">
                  <span class="variable-readonly-label">{{ resolvePreviewText(block) }}</span>
                </ng-container>
              </div>
              <div class="inspector-grid" *ngIf="isIconTextBlock(block)">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON' | translate }}</label>
                <button nz-button nzType="default" type="button" (click)="openIconPicker()">
                  {{ getIconOptionLabel(block.content?.icon) || ('QR_POSTER_TEMPLATE.BUILDER.CHOOSE_ICON' | translate) }}
                </button>
                <ng-container *ngIf="!isBlockContentVariable(block)">
                  <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT' | translate }}</label>
                  <textarea nz-input rows="3" [ngModel]="block.content?.text || ''" (ngModelChange)="updateSelectedBlockContent('text', $event)"></textarea>
                </ng-container>
                <ng-container *ngIf="isBlockContentVariable(block)">
                  <span class="variable-readonly-label">{{ resolvePreviewText(block) }}</span>
                </ng-container>
              </div>
              <div class="inspector-grid" *ngIf="isIconMultilineTextBlock(block)">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON' | translate }}</label>
                <button nz-button nzType="default" type="button" (click)="openIconPicker()">
                  {{ getIconOptionLabel(block.content?.icon) || ('QR_POSTER_TEMPLATE.BUILDER.CHOOSE_ICON' | translate) }}
                </button>
                <ng-container *ngIf="!isBlockContentVariable(block)">
                  <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT' | translate }}</label>
                  <textarea nz-input rows="3" [ngModel]="block.content?.text || ''" (ngModelChange)="updateSelectedBlockContent('text', $event)"></textarea>
                </ng-container>
                <ng-container *ngIf="isBlockContentVariable(block)">
                  <span class="variable-readonly-label">{{ resolvePreviewText(block) }}</span>
                </ng-container>
              </div>
              <div class="inspector-grid" *ngIf="isImageBlock(block)">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.UPLOAD_IMAGE' | translate }}</label>
                <input #imageFileInput type="file" accept="image/png,image/jpeg" class="visually-hidden-file-input" (change)="onImageFileSelected($event)" />
                <button nz-button nzType="default" type="button" (click)="triggerImageFilePicker(imageFileInput)">
                  {{ getImageUploadButtonLabel(block) }}
                </button>
                <div class="image-status-note">{{ getImageStatusLabel(block) }}</div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.IMAGE_FIT' | translate }}</label>
                <nz-select [ngModel]="block.content?.fit || 'cover'" (ngModelChange)="updateSelectedBlockContent('fit', $event)">
                  <nz-option nzValue="contain" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.IMAGE_FIT_CONTAIN' | translate"></nz-option>
                  <nz-option nzValue="cover" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.IMAGE_FIT_COVER' | translate"></nz-option>
                  <nz-option nzValue="stretch" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.IMAGE_FIT_STRETCH' | translate"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_RADIUS' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderRadius || 0" (ngModelChange)="updateSelectedBlockStyle('borderRadius', $event)" [nzMin]="0" [nzMax]="20" [nzStep]="0.5"></nz-input-number>
                <button nz-button nzType="default" type="button" (click)="clearSelectedImage()">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.REMOVE_IMAGE' | translate }}
                </button>
              </div>
              <div class="inspector-grid" *ngIf="isIconBlock(block)">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON' | translate }}</label>
                <button nz-button nzType="default" type="button" (click)="openIconPicker()">
                  {{ getIconOptionLabel(block.content?.icon) || ('QR_POSTER_TEMPLATE.BUILDER.CHOOSE_ICON' | translate) }}
                </button>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isTextBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FONT_SIZE' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.fontSize || 10" (ngModelChange)="updateSelectedBlockStyle('fontSize', $event)" [nzMin]="6" [nzMax]="48"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.WEIGHT' | translate }}</label>
                <nz-select [ngModel]="block.style?.fontWeight || 'normal'" (ngModelChange)="updateSelectedBlockStyle('fontWeight', $event)">
                  <nz-option nzValue="normal" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_NORMAL' | translate"></nz-option>
                  <nz-option nzValue="bold" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_BOLD' | translate"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ALIGN' | translate }}</label>
                <nz-select [ngModel]="block.style?.textAlign || 'left'" (ngModelChange)="updateSelectedBlockStyle('textAlign', $event)">
                  <nz-option nzValue="left" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_LEFT' | translate"></nz-option>
                  <nz-option nzValue="center" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_CENTER' | translate"></nz-option>
                  <nz-option nzValue="right" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_RIGHT' | translate"></nz-option>
                </nz-select>
                <label>
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT' | translate }}
                  <span nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT_TOOLTIP' | translate" class="info-icon">
                    <i nz-icon nzType="info-circle"></i>
                  </span>
                </label>
                <nz-select [ngModel]="block.style?.textFit || 'wrap'" (ngModelChange)="updateSelectedBlockStyle('textFit', $event)">
                  <nz-option nzValue="wrap" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT_WRAP' | translate"></nz-option>
                  <nz-option nzValue="shrink" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT_SHRINK' | translate"></nz-option>
                  <nz-option nzValue="singleLineShrink" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT_SINGLE_LINE_SHRINK' | translate"></nz-option>
                </nz-select>
                <div class="inspector-help-text">
                  {{ getSelectedTextFitHelpKey() | translate }}
                </div>
                <div class="template-color-warning template-color-warning--text-fit" *ngIf="isSelectedBlockWrapTextFitClipRisk()">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT_CLIP_WARNING' | translate }}
                </div>
                <button
                  *ngIf="isSelectedBlockWrapTextFitClipRisk()"
                  nz-button
                  nzType="default"
                  type="button"
                  class="text-fit-fix-button"
                  (click)="applyShrinkToSelectedBlock()"
                >
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT_USE_SHRINK' | translate }}
                </button>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.color || '#111827'" (ngModelChange)="updateSelectedBlockColor('color', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('color')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BACKGROUND' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [nzAllowClear]="true" [ngModel]="block.style?.backgroundColor || ''" (ngModelChange)="updateSelectedBlockColor('backgroundColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('backgroundColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [nzAllowClear]="true" [ngModel]="block.style?.borderColor || ''" (ngModelChange)="updateSelectedBlockColor('borderColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('borderColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_WIDTH' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderWidth || 0" (ngModelChange)="updateSelectedBlockStyle('borderWidth', $event)" [nzMin]="0" [nzMax]="6" [nzStep]="0.1"></nz-input-number>
                <div class="inspector-help-text" *ngIf="showBorderColorVisibilityHint">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_COLOR_WIDTH_HINT' | translate }}
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_RADIUS' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderRadius || 0" (ngModelChange)="updateSelectedBlockStyle('borderRadius', $event)" [nzMin]="0" [nzMax]="20" [nzStep]="0.5"></nz-input-number>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isIconTextBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FONT_SIZE' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.fontSize || 10" (ngModelChange)="updateSelectedBlockStyle('fontSize', $event)" [nzMin]="6" [nzMax]="48"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.WEIGHT' | translate }}</label>
                <nz-select [ngModel]="block.style?.fontWeight || 'normal'" (ngModelChange)="updateSelectedBlockStyle('fontWeight', $event)">
                  <nz-option nzValue="normal" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_NORMAL' | translate"></nz-option>
                  <nz-option nzValue="bold" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_BOLD' | translate"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ALIGN' | translate }}</label>
                <nz-select [ngModel]="block.style?.textAlign || 'center'" (ngModelChange)="updateSelectedBlockStyle('textAlign', $event)">
                  <nz-option nzValue="left" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_LEFT' | translate"></nz-option>
                  <nz-option nzValue="center" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_CENTER' | translate"></nz-option>
                  <nz-option nzValue="right" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_RIGHT' | translate"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.color || '#111827'" (ngModelChange)="updateSelectedBlockColor('color', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('color')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.iconColor || block.style?.color || '#006fc9'" (ngModelChange)="updateSelectedBlockStyle('iconColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('iconColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON_SPACING' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.gap || 1.5" (ngModelChange)="updateSelectedBlockStyle('gap', $event)" [nzMin]="0.5" [nzMax]="4" [nzStep]="0.1"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.UNGROUP_ROW' | translate }}</label>
                <button nz-button nzType="default" type="button" (click)="ungroupSelectedIconTextRow()">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.UNGROUP_ROW' | translate }}
                </button>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isIconMultilineTextBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FONT_SIZE' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.fontSize || 10" (ngModelChange)="updateSelectedBlockStyle('fontSize', $event)" [nzMin]="6" [nzMax]="48"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.WEIGHT' | translate }}</label>
                <nz-select [ngModel]="block.style?.fontWeight || 'normal'" (ngModelChange)="updateSelectedBlockStyle('fontWeight', $event)">
                  <nz-option nzValue="normal" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_NORMAL' | translate"></nz-option>
                  <nz-option nzValue="bold" [nzLabel]="'QR_POSTER_TEMPLATE.BUILDER.STYLE_BOLD' | translate"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.color || '#111827'" (ngModelChange)="updateSelectedBlockColor('color', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('color')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.iconColor || block.style?.color || '#006fc9'" (ngModelChange)="updateSelectedBlockStyle('iconColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('iconColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ICON_SPACING' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.gap || 3" (ngModelChange)="updateSelectedBlockStyle('gap', $event)" [nzMin]="0.5" [nzMax]="4" [nzStep]="0.1"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.TEXT_FIT' | translate }}</label>
                <nz-select [ngModel]="block.style?.textFit || 'shrink'" (ngModelChange)="updateSelectedBlockStyle('textFit', $event)">
                  <nz-option nzValue="wrap" nzLabel="Wrap"></nz-option>
                  <nz-option nzValue="shrink" nzLabel="Shrink"></nz-option>
                  <nz-option nzValue="singleLineShrink" nzLabel="Single Line"></nz-option>
                </nz-select>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.UNGROUP_ROW' | translate }}</label>
                <button nz-button nzType="default" type="button" (click)="ungroupSelectedIconMultilineText()">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.UNGROUP_ROW' | translate }}
                </button>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isIconBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.color || '#111827'" (ngModelChange)="updateSelectedBlockColor('color', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('color')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isRectangleBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FILL_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [nzAllowClear]="true" [ngModel]="block.style?.backgroundColor || ''" (ngModelChange)="updateSelectedBlockColor('backgroundColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('backgroundColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [nzAllowClear]="true" [ngModel]="block.style?.borderColor || ''" (ngModelChange)="updateSelectedBlockColor('borderColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('borderColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_WIDTH' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderWidth || 0" (ngModelChange)="updateSelectedBlockStyle('borderWidth', $event)" [nzMin]="0" [nzMax]="6" [nzStep]="0.1"></nz-input-number>
                <div class="inspector-help-text" *ngIf="showBorderColorVisibilityHint">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_COLOR_WIDTH_HINT' | translate }}
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.BORDER_RADIUS' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderRadius || 0" (ngModelChange)="updateSelectedBlockStyle('borderRadius', $event)" [nzMin]="0" [nzMax]="20" [nzStep]="0.5"></nz-input-number>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isLineBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.LINE_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.borderColor || block.style?.color || '#111827'" (ngModelChange)="updateSelectedBlockColor('borderColor', $event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('borderColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.LINE_THICKNESS' | translate }}</label>
                <nz-input-number [ngModel]="block.style?.borderWidth || 0.2" (ngModelChange)="updateSelectedBlockStyle('borderWidth', $event)" [nzMin]="0.1" [nzMax]="6" [nzStep]="0.1"></nz-input-number>
              </div>
            </section>

            <section class="inspector-section" *ngIf="isFooterBlock(block)">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.STYLE' | translate }}</div>
              <div class="inspector-grid">
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FOOTER_BACKGROUND' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.backgroundColor || '#d9d9d9'" (ngModelChange)="updateFooterBackground($event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('backgroundColor')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.FOOTER_TEXT_COLOR' | translate }}</label>
                <div class="color-control-row">
                  <nz-color-picker nzFormat="hex" [nzShowText]="true" [ngModel]="block.style?.color || '#000000'" (ngModelChange)="updateFooterTextColor($event)"></nz-color-picker>
                  <button nz-button nzType="default" type="button" class="eyedropper-button" (click)="pickColorForSelectedBlock('color')" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.EYEDROPPER' | translate">
                    <i nz-icon nzType="bg-colors"></i>
                  </button>
                </div>
                <div class="template-color-warning" *ngIf="isFooterTextContrastWarningVisible(block)">
                  {{ 'QR_POSTER_TEMPLATE.BUILDER.FOOTER_TEXT_COLOR_WARNING' | translate }}
                </div>
              </div>
            </section>

            <section class="inspector-section">
              <div class="inspector-title">{{ 'QR_POSTER_TEMPLATE.BUILDER.BRANDING' | translate }}</div>
              <div class="toggle-row">
                <span>{{ 'QR_POSTER_TEMPLATE.BUILDER.WHITE_LABEL' | translate }}</span>
                <span nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.WHITE_LABEL_BUSINESS_ONLY' | translate" [nzTooltipTrigger]="!isBusinessPlan ? 'hover' : null">
                  <nz-switch
                    [ngModel]="!workingTemplate!.branding.showScanafyFooter"
                    (ngModelChange)="updateFooterVisibility($event)"
                    [nzDisabled]="!isBusinessPlan"
                  ></nz-switch>
                </span>
              </div>
            </section>

            <details class="inspector-advanced-position" open>
              <summary>{{ 'QR_POSTER_TEMPLATE.BUILDER.ADVANCED_POSITION' | translate }}</summary>
              <div class="inspector-grid inspector-grid--frame">
                <label>X</label>
                <nz-input-number [ngModel]="block.x" (ngModelChange)="updateSelectedBlockFrame('x', $event)" [nzStep]="0.1" [nzPrecision]="2"></nz-input-number>
                <label>Y</label>
                <nz-input-number [ngModel]="block.y" (ngModelChange)="updateSelectedBlockFrame('y', $event)" [nzStep]="0.1" [nzPrecision]="2"></nz-input-number>
                <label>W</label>
                <nz-input-number [ngModel]="block.width" (ngModelChange)="updateSelectedBlockFrame('width', $event)" [nzMin]="block.type === 'line' ? 0.1 : 1" [nzStep]="0.1" [nzPrecision]="2" [nzDisabled]="!isSizeEditable(block)"></nz-input-number>
                <label>H</label>
                <nz-input-number [ngModel]="block.height" (ngModelChange)="updateSelectedBlockFrame('height', $event)" [nzMin]="block.type === 'line' ? 0.1 : 0.5" [nzStep]="0.1" [nzPrecision]="2" [nzDisabled]="!isSizeEditable(block)"></nz-input-number>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.ROTATION' | translate }}</label>
                <div class="rotation-control">
                  <nz-input-number [ngModel]="selectedBlockRotation" (ngModelChange)="updateSelectedBlockRotation($event)" [nzMin]="-180" [nzMax]="180" [nzStep]="1"></nz-input-number>
                  <button nz-button nzType="default" type="button" nzSize="small" class="rotation-reset-button" (click)="resetSelectedBlockRotation()" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.RESET_ROTATION_TOOLTIP' | translate">
                    <i nz-icon nzType="reload"></i>
                  </button>
                </div>
                <label>{{ 'QR_POSTER_TEMPLATE.BUILDER.LAYER' | translate }}</label>
                <div class="layer-control">
                  <span class="layer-value">{{ selectedBlockLayerText }}</span>
                  <div class="layer-buttons">
                    <button nz-button nzType="default" type="button" nzSize="small" (click)="sendSelectedBlockBackward()" [disabled]="!canSendSelectedBlockBackward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.SEND_BACKWARD' | translate">
                      <i nz-icon nzType="down"></i>
                    </button>
                    <button nz-button nzType="default" type="button" nzSize="small" (click)="bringSelectedBlockForward()" [disabled]="!canBringSelectedBlockForward" nz-tooltip [nzTooltipTitle]="'QR_POSTER_TEMPLATE.BUILDER.BRING_FORWARD' | translate">
                      <i nz-icon nzType="up"></i>
                    </button>
                  </div>
                </div>
              </div>
            </details>
            </ng-container>
          </ng-template>

          <ng-template #emptyInspector>
            <p class="empty-state">{{ 'QR_POSTER_TEMPLATE.BUILDER.EMPTY_STATE' | translate }}</p>
          </ng-template>
        </aside>
      </div>
    </div>

    <div *ngIf="builderMode === 'sign-order'" class="sign-order-content">
      <div class="sign-order-sub-nav">
        <button nz-button [nzType]="signOrderSubMode === 'history' ? 'primary' : 'default'" (click)="onSignOrderSubNavigation('history')">
          <i nz-icon nzType="ordered-list"></i>
          {{ 'QR_POSTER_TEMPLATE.SIGN_ORDER_MY_ORDERS' | translate }}
        </button>
      </div>

      <ng-container [ngSwitch]="signOrderSubMode">
        <app-sign-order-new *ngSwitchCase="'new'"
          [draftPublicId]="selectedDraftPublicId"
          [freshOrderSession]="freshSignOrderSession"
          (navigateOrder)="openSignOrderDetail($event)"
          (navigateOrders)="onSignOrderSubNavigation('history')"
          (draftSaved)="onDraftSaved($event)"
          (draftConsumed)="onDraftConsumed()"
          (draftDeleted)="onDraftDeleted()">
        </app-sign-order-new>

        <app-sign-order-list *ngSwitchCase="'history'"
          [embedded]="true"
          (selectOrder)="openSignOrderDetail($event)"
          (newOrder)="startNewSignOrder()"
          (resumeDraft)="openSignOrderDraft($event)">
        </app-sign-order-list>

        <app-sign-order-detail *ngSwitchCase="'detail'"
          [publicId]="selectedOrderPublicId"
          [embedded]="true"
          (navigateBack)="onSignOrderDetailBack()">
        </app-sign-order-detail>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #iconPickerContent>
    <div class="icon-picker-grid">
      <div class="empty-state" *ngIf="!iconOptions.length">
        {{ 'QR_POSTER_TEMPLATE.BUILDER.NO_ICONS' | translate }}
      </div>
      <button
        nz-button
        nzType="default"
        type="button"
        *ngFor="let option of iconOptions"
        class="icon-picker-option"
        nz-tooltip
        [nzTooltipTitle]="option.labelKey | translate"
        (click)="applyIconSelection(option.key)"
      >
        <i nz-icon [nzType]="option.nzType"></i>
        <span>{{ option.labelKey | translate }}</span>
      </button>
    </div>
  </ng-template>

  <ng-template #templateNameModalContent>
    <div class="template-name-modal">
      <p>{{ 'QR_POSTER_TEMPLATE.BUILDER.NAME_TEMPLATE_MESSAGE' | translate }}</p>
      <input nz-input [(ngModel)]="pendingTemplateNameDraft" (ngModelChange)="onTemplateNameDraftChange($event)" />
      <div class="template-name-error" *ngIf="templateNameValidationError">{{ templateNameValidationError }}</div>
    </div>
  </ng-template>
  <ng-template #renameTemplateModalContent>
    <div class="template-name-modal">
      <p>{{ 'QR_POSTER_TEMPLATE.BUILDER.RENAME_TEMPLATE_MESSAGE' | translate }}</p>
      <input nz-input [(ngModel)]="pendingRenameNameDraft" (ngModelChange)="onRenameNameDraftChange($event)" />
      <div class="template-name-error" *ngIf="renameNameValidationError">{{ renameNameValidationError }}</div>
    </div>
  </ng-template>

  <div class="sign-order-unavailable" *ngIf="signOrderUnavailable && !showSignOrderCta && signOrderRouteNotice !== 'unavailable'">
    <p class="unavailable-note">{{ 'QR_POSTER_TEMPLATE.SIGN_ORDER_UNAVAILABLE' | translate }}</p>
    <p class="unavailable-reason" *ngIf="catalogReason">{{ catalogReason }}</p>
  </div>

  <div class="layer-order-overlay" *ngIf="layerModalVisible" (click)="closeLayerModal()">
    <div class="layer-order-panel" cdkDrag (click)="$event.stopPropagation()">
      <div class="layer-order-panel-header" cdkDragHandle>
        <i nz-icon nzType="ordered-list"></i>
        <span>{{ 'QR_POSTER_TEMPLATE.BUILDER.LAYER_ORDER' | translate }}</span>
        <button nz-button nzType="text" nzShape="circle" type="button" (click)="closeLayerModal()" class="layer-order-close-btn">
          <i nz-icon nzType="close"></i>
        </button>
      </div>
      <div class="layer-order-modal">
        <p class="layer-order-helper">{{ 'QR_POSTER_TEMPLATE.BUILDER.LAYER_HELPER' | translate }}</p>
        <div cdkDropList class="layer-order-list" (cdkDropListDropped)="onLayerDrop($event)">
          <div
            class="layer-order-item"
            *ngFor="let block of orderedBlocksForLayerModal; let i = index"
            cdkDrag
            [class.layer-order-item--selected]="selectedBlockIds.includes(block.id)"
            tabindex="0"
            role="button"
            (click)="onLayerItemSelect(block, $event)"
            (keydown.enter)="onLayerItemSelect(block, $event)"
            (keydown.space)="onLayerItemSelect(block, $event)"
          >
            <i nz-icon nzType="menu" class="layer-order-drag-handle" cdkDragHandle></i>
            <span class="layer-order-index">{{ i + 1 }}</span>
            <span class="layer-order-label">{{ getLayerBlockLabel(block) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
